import { supabase } from '../supabase';
import { CreateBankAccountParams, BankAccount } from '../types/bank_accounts';

export const createBankAccount = async (params: CreateBankAccountParams) => {
  const { data, error } = await supabase
    .from('bank_accounts')
    .insert(params)
    .single();

  if (error) throw error;
  return data;
};

export const fetchBankAccount = async (
  taskerId: number
): Promise<BankAccount | null> => {
  const { data, error } = await supabase
    .from('bank_accounts')
    .select('*')
    .eq('tasker_id', taskerId)
    .single();

  if (error) {
    if (error.code === 'PGRST116') {
      // No bank account found for this tasker
      return null;
    }
    throw error;
  }
  return data;
};

export const getBankAccountByTaskerId = (taskerId: number) => {
  return supabase
  .from('bank_accounts')
  .select('*')
  .eq('tasker_id', taskerId)
  .maybeSingle();
}